<div>
    <p><strong>First Name: {{profile?.givenName}}</strong></p>
    <p><strong>Last Name: {{profile?.surname}}</strong></p>
    <p><strong>Email: {{profile?.userPrincipalName}}</strong></p>
    <p><strong>Id: {{profile?.id}}</strong></p>
</div>